/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_This_Listing_This_CannInputs */

const en_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this listing? This cannot be undone.`)
};

const es_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar este anuncio? Esto no se puede deshacer.`)
};

const fr_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cette annonce ? Cette action ne peut pas être annulée.`)
};

const de_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Inserat löschen? Dies kann nicht rückgängig gemacht werden.`)
};

const ja_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この出品を削除しますか？この操作は取り消せません。`)
};

const zh_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除该商品？此操作无法撤销。`)
};

const ar_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل ترغب في حذف هذا الإعلان؟ لا يمكن التراجع عن هذا الإجراء.`)
};

const id_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus listing ini? Tindakan ini tidak dapat dibatalkan.`)
};

const it_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare questo annuncio? Questa azione non può essere annullata.`)
};

const ru_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить это объявление? Это действие нельзя отменить.`)
};

const pt_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir este anúncio? Isso não pode ser desfeito.`)
};

const ko_delete_this_listing_this_cann = /** @type {(inputs: Delete_This_Listing_This_CannInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 상품을 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.`)
};

/**
* | output |
* | --- |
* | "Delete this listing? This cannot be undone." |
*
* @param {Delete_This_Listing_This_CannInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delete_this_listing_this_cann = /** @type {((inputs?: Delete_This_Listing_This_CannInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_This_Listing_This_CannInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_this_listing_this_cann(inputs)
	if (locale === "es") return es_delete_this_listing_this_cann(inputs)
	if (locale === "fr") return fr_delete_this_listing_this_cann(inputs)
	if (locale === "de") return de_delete_this_listing_this_cann(inputs)
	if (locale === "ja") return ja_delete_this_listing_this_cann(inputs)
	if (locale === "zh") return zh_delete_this_listing_this_cann(inputs)
	if (locale === "ar") return ar_delete_this_listing_this_cann(inputs)
	if (locale === "id") return id_delete_this_listing_this_cann(inputs)
	if (locale === "it") return it_delete_this_listing_this_cann(inputs)
	if (locale === "ru") return ru_delete_this_listing_this_cann(inputs)
	if (locale === "pt") return pt_delete_this_listing_this_cann(inputs)
	return ko_delete_this_listing_this_cann(inputs)
});